import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted Inter (bundled → CSP-safe, works offline). Loads only the weights
// the UI actually uses.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@blocknote/core/style.css';
import '@blocknote/mantine/style.css';
import App from './App';
import { installDiagnostics } from './feedback/diagnostics';
import { PublicShare } from './pages/dam/public/PublicShare';   // --- DAM module (removable) ---
import { OutfitterSurface } from './pages/outfitter';           // --- Outfitter module (removable) ---
import { surfaceFor, isLodgeHost, lodgeRedirectFor } from './pages/outfitter/shared/lodgeHost'; // --- Outfitter module (removable) ---

// Outfitter module surfaces render OUTSIDE the MSAL-gated app (external tenant
// operators + no-login guests), and own the whole of the Lodge address
// (lodge.harvus.com) — see pages/outfitter/shared/lodgeHost.js.
// --- Outfitter module (removable) ---
const _loc = window.location;
const _lodgeExtra = process.env.REACT_APP_LODGE_HOSTS || '';
const _lodgeRedirect = lodgeRedirectFor({
  hostname: _loc.hostname, pathname: _loc.pathname, search: _loc.search, hash: _loc.hash,
  lodgeOrigin: process.env.REACT_APP_LODGE_ORIGIN || '', extraHosts: _lodgeExtra,
});
if (_lodgeRedirect) window.location.replace(_lodgeRedirect);
const onLodgeHost = isLodgeHost(_loc.hostname, _lodgeExtra);
if (onLodgeHost) document.title = 'Harvus Lodge';
const outfitterSurface = surfaceFor({ hostname: _loc.hostname, pathname: _loc.pathname, extraHosts: _lodgeExtra });

// Public, no-login DAM share links live at /s/<token> and render OUTSIDE the
// MSAL-gated app — never on the Lodge address. --- DAM module (removable) ---
const isPublicShare = !onLodgeHost && window.location.pathname.startsWith('/s/');

// Record recent errors and failed API calls so a Feedback report can carry them.
installDiagnostics();

function renderRoot() {
  if (_lodgeRedirect) return null; // leaving for the Lodge address
  if (isPublicShare) return <PublicShare />;
  if (outfitterSurface) return <OutfitterSurface surface={outfitterSurface} />;
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode>{renderRoot()}</React.StrictMode>);
